export enum AuthActionTypes {
  SET_STATE = 'AUTH.SET_STATE',
  GET_ACCESS_TOKEN = 'AUTH.GET_ACCESS_TOKEN',
  REFRESH_ACCESS_TOKEN = 'AUTH.REFRESH_ACCESS_TOKEN',
  LOG_OUT = 'AUTH.LOG_OUT',
  GET_PASSPORT = 'AUTH.GET_PASSPORT',
  HAS_PASSPORT = 'AUTH.HAS_PASSPORT',
}
